import { Injectable } from '@angular/core';
import authHeader from '../helpers/auth-header';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, map } from 'rxjs';
import { DriverReportView } from '../interfaces/driverReportView';
import { DriverDashboardRecord } from '../interfaces/driverDashboardRecord';
import axios from 'axios';

@Injectable({
  providedIn: 'root'
})
export class RecordsService {

  constructor(private http: HttpClient) { }

 
  getRecords(pageNumber: number, itemsPerPage: number, sortCol: string, sortDir: string, username: string): any {
    const config = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': authHeader()
        }
    };
    const url = `${environment.APP_API_URL}/api/v1/DriverDashboard/getDashboardPage?pageNumber=${pageNumber}&itemsPerPage=${itemsPerPage}&sortCol=${this.translateSortCol(sortCol)}&sortDir=${sortDir.toLowerCase() === 'asc' ? 'ASC' : 'DESC'}&driverUserName=${username}`;
    return axios.get(url, config)
        .then((response) => {
            if (response) {
                return response.data;
            }
            return null;
        })
        .catch((error) => {
            console.error(error);
            return null;
        });
}

getAccountHolderRecords(pageNumber: number, itemsPerPage: number, sortCol: string, sortDir: string, username: string, searchText: string): any {
    const config = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': authHeader()
        }
    };

    let url = `${environment.APP_API_URL}/api/v1/AccountHolderRecords/GetDashboardPage?pageNumber=${pageNumber}&itemsPerPage=${itemsPerPage}&sortCol=${sortCol}&sortDir=${sortDir.toLowerCase()}&driverUserName=${username}`;
    if (searchText !== '') {
        url += `&searchText=${searchText}`;
    }

    return axios.get(url, config)
        .then((response) => {
            if (response) {
                return response.data;
            }
            return null;
        })
        .catch((error) => {
            console.error(error);
            return null;
        });
}

getAccountHolderRecordsObservable(pageNumber: number, itemsPerPage: number, sortCol: string, sortDir: string, username: string, searchText: string): Observable<DriverDashboardRecord[]> {
    const config = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': authHeader()
        }
    };

    let url = `${environment.APP_API_URL}/api/v1/AccountHolderRecords/GetDashboardPage?pageNumber=${pageNumber}&itemsPerPage=${itemsPerPage}&sortCol=${sortCol}&sortDir=${sortDir.toLowerCase()}&driverUserName=${username}`;
    if (searchText !== '') {
        url += `&searchText=${searchText}`;
    }

    return new Observable<DriverDashboardRecord[]>(observer => {
        this.http.get<any>(url, config).pipe(
            map((response: any) => {
                if (response?.items) {
                    response.items = response.items.map((item: any) => ({
                        ...item,
                        monitor: item.monitor ?? item.Monitor ?? false
                    }));
                }
                return response;
            })
        ).subscribe((data: any) => {
            observer.next(data);
        });
    });
}

updateMonitorState(authCode: string, monitor: boolean): Promise<boolean> {
    const config = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': authHeader()
        }
    };
    const url = `${environment.APP_API_URL}/api/v1/AccountHolderRecords/updateMonitorState?authCode=${authCode}&monitor=${monitor}`;
    return axios.put(url, {}, config)
        .then((response) => {
            return response && response.status === 200;
        });
}

updateDriverConsent(authCode: string, hasConfirmedConsent: boolean): any {
    const config = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': authHeader()
        }
    };

    const url = `${environment.APP_API_URL}/api/v1/AccountHolderRecords/updateDriverConsent?authCode=${authCode}&doesConsent=${hasConfirmedConsent}`;
    return axios.put(url, {}, config)
        .then((response) => {
            if (response && response.status === 200) {
                return true;
            }
            return false;
        })
        .catch((error) => {
            if (error && error.response && error.response.status === 401) {
                return "Unauthorized";
            } else {
                console.error(error);
                return false
            }
        });
}

translateSortCol(columnName: string) {
    if (columnName === 'lastName') {
        return 'LAST_NAME';
    }
    if (columnName === 'driverLicenseNumber') {
        return 'DL_NUMBER';
    }
    if (columnName === 'driverLicenseState') {
        return 'DL_STATE';
    }
    return 'REQUEST_DATE';
}

recordDriverRecordView(reportView: DriverReportView) {
    const config = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': authHeader()
        }
    };

    const payload = (JSON.parse(JSON.stringify(reportView)));

    const url: string = `${environment.APP_API_URL}/api/v1/DriverRecord/DriverRecordReportView`;
    return axios.post(url, payload, config)
        .then((response) => {
            if (response && response.status === 200) {
                return true;
            }
            return false;
        })
        .catch((error) => {
            console.error(error);
            return false;
        });
}
}
